import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PlusOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PlusOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M22 11h-9V2h-2v9H2v2h9v9h2v-9h9v-2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default PlusOutlined;